import validate from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.4_db0@0.2.4_eslint@10.2.1_jiti@2.4.2__ior_f573ykspucr5i56m45vmcehyxm/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45middleware_45global from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/middleware/route-middleware.global.ts";
import manifest_45route_45rule from "/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.4_db0@0.2.4_eslint@10.2.1_jiti@2.4.2__ior_f573ykspucr5i56m45vmcehyxm/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45middleware_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "my-middleware": () => import("/Users/godlikeyoung/Documents/Dev/Code/MARCO/marco-mall/middleware/my-middleware.ts")
}